/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseSalesInfo } from '../models/ApiResponseSalesInfo';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SalesControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns ApiResponseSalesInfo OK
   * @throws ApiError
   */
  public getSales({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseSalesInfo> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/sales/',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * @returns ApiResponseSalesInfo OK
   * @throws ApiError
   */
  public getSales1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseSalesInfo> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/sales',
      query: {
        'vin': vin,
      },
    });
  }
}
